import { createActions } from 'redux-actions';
import keyMirror from 'keymirror';

export const constants = keyMirror({
    FETCH_GEOFENCES_REQUEST: null,
    FETCH_GEOFENCES_SUCCESS: null,
    FETCH_GEOFENCES_FAILURE: null,
});

export const {
    fetchGeofencesRequest,
    fetchGeofencesSuccess,
    fetchGeofencesFailure,
} = createActions(
    constants.FETCH_GEOFENCES_REQUEST,
    constants.FETCH_GEOFENCES_SUCCESS,
    constants.FETCH_GEOFENCES_FAILURE,
);